// extracted by mini-css-extract-plugin
module.exports = {"SizesMenu":"styles_SizesMenu__2bQWw","menuTitle":"styles_menuTitle__VLMtj"};